import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";
import { typography } from "./typography";
import { components } from "./components";
import { breakpoints, shape, spacing } from "./breakpoints";

// Create the theme
const theme = createTheme({
  palette: colors,
  typography,
  components,
  breakpoints,
  spacing,
  shape,
});

export default theme;
